import script from "./pageHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./pageHeader.vue?vue&type=script&setup=true&lang=js"

import "./pageHeader.vue?vue&type=style&index=0&id=86d8dc88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86d8dc88"]])

export default __exports__